import axios from "axios";
import { SERVER_DOMAIN } from "../project_config";
import { LoginHelper } from "./LoginHelper";

let BASE_URL = process.env.API_DOMAIN;
if (BASE_URL == null) {
    BASE_URL = SERVER_DOMAIN;
}

const getAccessToken = async () => {
    const refreshToken = localStorage.getItem("refresh-token");
    if (!refreshToken) return;
    const data = await postRequest(
        BASE_URL + "/api/v1/account/token/refresh/",
        {
            refresh: refreshToken,
        },
    );
    if (data.access) {
        localStorage.setItem("access-token", data.access);
        return data.access;
    }
};

class RequestError extends Error {
    status;
    data;
    constructor(status, data) {
        super(`Request failed with status ${status}`);
        this.status = status;
        this.data = data;
    }
}

export const getRequest = async (
    url,
    options,
    failedCount = 0) => {

    const res = await fetch(url, {
        ...options,
        headers: {
            ...options?.headers
        },
    });
    if (res.status === 401 || res.status === 403) {
        if (failedCount === 0) {
            // Try refresh token
            const newToken = await getAccessToken();
            if (newToken) {
                return getRequest(url, options, failedCount + 1);
            }
        }
        throw new Error("Not Authorized");
    }

    if (res.status >= 300 || res.status < 200) {
        throw new Error(res.statusText);
    }
    return res.json();
};

export const postRequest = async (
    url,
    body,
    options,
    failedCount = 0
) => {
    const { withFormData = false } = options || {};

    let formData;
    if (withFormData) {
        formData = new FormData();
        for (let key in body) {
            // @ts-expect-error
            formData.append(key, body[key]);
        }
    }

    const res = await fetch(url, {
        method: "POST",
        // @ts-expect-error
        body: withFormData ? formData : JSON.stringify(body),
        ...options,
        headers: {
            ...(!withFormData && { "Content-Type": "application/json" }),
            ...options?.headers,
        },
    });

    if (res.status >= 300 || res.status < 200) {
        // if (res.status === 401 || res.status === 403) {
        //     throw new RequestError("Not Authorized");
        // }
        const errorData = await res.json();
        throw new RequestError(res.status, errorData);
    }
    return res.json();
};


export const postRequestAxios = async (
    url,
    body,
    options,
    failedCount = 0
) => {
    const { withFormData = false } = options || {};

    let formData;
    if (withFormData) {
        formData = new FormData();
        for (let key in body) {
            // @ts-expect-error
            formData.append(key, body[key]);
        }
    }

    const res = await axios.post(url, withFormData ? formData : JSON.stringify(body), {
        headers: {
            "Content-Type": "multipart/form-data",
            ...options?.headers,
        },
    });

    if (res.status !== 200 && res.status !== 201) {
        console.log("Response status: " + res.status);
        if (res.status === 401 || res.status === 403) {
            throw new Error("Not Authorized");
        }
        throw new Error(res.statusText);
    }
    return res.data;
};


// auth
const profileLogin = async (body) => {
    return postRequest(BASE_URL + '/api/v1/profile/otp_login/', body, {
        withFormData: true,
        method: "POST",
    });
};
const profileVerify = async (body) => {
    return postRequest(BASE_URL + '/api/v1/profile/otp_verify/', body, {
        withFormData: true,
        method: "POST",
    });
};


// home
const homeTagList = async (body) => {
    return postRequest(BASE_URL + '/api/v1/home/list_tags/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const homeFetchTag = async (body) => {
    return postRequest(BASE_URL + '/api/v1/home/fetch_tag/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const homeHeroSlides = async (viewport = 'desktop') => {
    const v = viewport === 'mobile' ? 'mobile' : 'desktop';
    return getRequest(BASE_URL + `/api/v1/home/hero_slides/?viewport=${encodeURIComponent(v)}`);
};
const homeHeroAdminList = async (body) => {
    return postRequest(BASE_URL + '/api/v1/home/hero_admin_list/', body, { withFormData: true, method: 'POST' });
};
const homeHeroSave = async (body) => {
    return postRequest(BASE_URL + '/api/v1/home/hero_save/', body, { withFormData: true, method: 'POST' });
};
const homeHeroRemove = async (body) => {
    return postRequest(BASE_URL + '/api/v1/home/hero_remove/', body, { withFormData: true, method: 'POST' });
};
const homeCarousels = async () => {
    let url = BASE_URL + '/api/v1/home/carousels/';
    const token = LoginHelper.getToken();
    if (token) {
        url += `?token=${encodeURIComponent(token)}`;
    }
    return getRequest(url);
};
const homeCarouselAdminList = async (body) => {
    return postRequest(BASE_URL + '/api/v1/home/carousel_admin_list/', body, { withFormData: true, method: 'POST' });
};
const homeCarouselSave = async (body) => {
    return postRequest(BASE_URL + '/api/v1/home/carousel_save/', body, { withFormData: true, method: 'POST' });
};
const homeCarouselRemove = async (body) => {
    return postRequest(BASE_URL + '/api/v1/home/carousel_remove/', body, { withFormData: true, method: 'POST' });
};
const homeCarouselItemSave = async (body) => {
    return postRequest(BASE_URL + '/api/v1/home/carousel_item_save/', body, { withFormData: true, method: 'POST' });
};
const homeCarouselItemRemove = async (body) => {
    return postRequest(BASE_URL + '/api/v1/home/carousel_item_remove/', body, { withFormData: true, method: 'POST' });
};


// profile
const profileDetail = async (body) => {
    return postRequest(BASE_URL + '/api/v1/profile/detail/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const profileFetchEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/profile/fetch_edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const profileEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/profile/edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const profileAdminUserList = async (body) => postRequest(BASE_URL + '/api/v1/profile/admin_user_list/', body, { withFormData: true, method: 'POST' });
const profileAdminUserSave = async (body) => postRequest(BASE_URL + '/api/v1/profile/admin_user_save/', body, { withFormData: true, method: 'POST' });
const profileAdminUserRemove = async (body) => postRequest(BASE_URL + '/api/v1/profile/admin_user_remove/', body, { withFormData: true, method: 'POST' });
const reportProfile = async (body) => {
    return postRequest(BASE_URL + '/api/v1/profile/report/', body, {
        withFormData: true,
        method: 'POST',
    });
};

// doctor
const doctorFetchEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/doctor/fetch_edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const doctorEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/doctor/edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const doctorSearch = async (body) => {
    return postRequest(BASE_URL + '/api/v1/doctor/search/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const doctorAdminList = async (body) => postRequest(BASE_URL + '/api/v1/doctor/admin_list/', body, { withFormData: true, method: 'POST' });
const doctorAdminSave = async (body) => postRequest(BASE_URL + '/api/v1/doctor/admin_save/', body, { withFormData: true, method: 'POST' });
const doctorAdminRemove = async (body) => postRequest(BASE_URL + '/api/v1/doctor/admin_remove/', body, { withFormData: true, method: 'POST' });


// payment
const paymentList = async (body) => {
    return postRequest(BASE_URL + '/api/v1/payment/list/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const paymentDetail = async (body) => {
    return postRequest(BASE_URL + '/api/v1/payment/detail/', body, {
        withFormData: true,
        method: 'POST',
    });
};

// subscriptions
const subscriptionList = async (body) => postRequest(BASE_URL + '/api/v1/subscription/list/', body, { withFormData: true, method: 'POST' });
const subscriptionAdminList = async (body) => postRequest(BASE_URL + '/api/v1/subscription/admin_list/', body, { withFormData: true, method: 'POST' });
const subscriptionSave = async (body) => postRequest(BASE_URL + '/api/v1/subscription/save/', body, { withFormData: true, method: 'POST' });
const subscriptionToggleActive = async (body) => postRequest(BASE_URL + '/api/v1/subscription/toggle_active/', body, { withFormData: true, method: 'POST' });
const subscriptionPreparePurchase = async (body) => postRequest(BASE_URL + '/api/v1/subscription/prepare_purchase/', body, { withFormData: true, method: 'POST' });
const subscriptionMyList = async (body) => postRequest(BASE_URL + '/api/v1/subscription/my_list/', body, { withFormData: true, method: 'POST' });

// video clips
const videoClipList = async (body) => postRequest(BASE_URL + '/api/v1/video_clip/list/', body, { withFormData: true, method: 'POST' });
const videoClipDetail = async (body) => postRequest(BASE_URL + '/api/v1/video_clip/detail/', body, { withFormData: true, method: 'POST' });
const videoClipWatch = async (body) => postRequest(BASE_URL + '/api/v1/video_clip/watch/', body, { withFormData: true, method: 'POST' });
const videoClipAdminList = async (body) => postRequest(BASE_URL + '/api/v1/video_clip/admin_list/', body, { withFormData: true, method: 'POST' });
const videoClipSave = async (body) => postRequest(BASE_URL + '/api/v1/video_clip/save/', body, { withFormData: true, method: 'POST' });
const videoClipRemove = async (body) => postRequest(BASE_URL + '/api/v1/video_clip/remove/', body, { withFormData: true, method: 'POST' });


// expertise
const expertiseList = async () => {
    return getRequest(BASE_URL + "/api/v1/expertise/list/");
};
const listDoctorExpertises = async (body) => {
    return postRequest(BASE_URL + '/api/v1/expertise/list_doctor_expertises/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const listWorkshopExpertises = async (body) => {
    return postRequest(BASE_URL + '/api/v1/expertise/list_workshop_expertises/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const listClipExpertises = async (body) => {
    return postRequest(BASE_URL + '/api/v1/expertise/list_clip_expertises/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const listWebinarExpertises = async (body) => {
    return postRequest(BASE_URL + '/api/v1/expertise/list_webinar_expertises/', body, {
        withFormData: true,
        method: 'POST',
    });
};


// category
const categoryList = async () => {
    return getRequest(BASE_URL + "/api/v1/category/list/");
};


// publication
const publicationDetail = async (body) => {
    return postRequest(BASE_URL + '/api/v1/publication/detail/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const publicationAdd = async (body) => {
    return postRequest(BASE_URL + '/api/v1/publication/add/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const publicationFetchEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/publication/fetch_edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const publicationEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/publication/edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const publicationRemove = async (body) => {
    return postRequest(BASE_URL + '/api/v1/publication/remove/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const publicationListMine = async (body) => {
    return postRequest(BASE_URL + '/api/v1/publication/list_mine/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const publicationListByProfile = async (body) => {
    return postRequest(BASE_URL + '/api/v1/publication/list_by_profile/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const publicationSearch = async (body) => {
    return postRequest(BASE_URL + '/api/v1/publication/search/', body, {
        withFormData: true,
        method: 'POST',
    });
};


// workshop
const workshopDetail = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/detail/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopAdd = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/add/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopFetchEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/fetch_edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopRemove = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/remove/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopAdminList = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/admin_list/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopListMine = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/list_mine/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopListEnroll = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/list_enroll/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopListByProfile = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/list_by_profile/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopListByExpertise = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/list_by_expertise/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopSearch = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/search/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopEnroll = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/enroll/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopPreparePurchase = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/prepare_purchase/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopCalculateDiscountCode = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/calculate_discount_code/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const episodeAdd = async (body) => {
    return postRequest(BASE_URL + '/api/v1/episode/add/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const episodeFetchEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/episode/fetch_edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const episodeEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/episode/edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const episodeRemove = async (body) => {
    return postRequest(BASE_URL + '/api/v1/episode/remove/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const workshopAdminConfirm = async (body) => {
    return postRequest(BASE_URL + '/api/v1/workshop/admin_confirm/', body, {
        withFormData: true,
        method: 'POST',
    });
};


// discussion
const discussionDetail = async (body) => {
    return postRequest(BASE_URL + '/api/v1/discussion/detail/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const discussionAdd = async (body) => {
    return postRequest(BASE_URL + '/api/v1/discussion/add/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const discussionEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/discussion/edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const discussionRemove = async (body) => {
    return postRequest(BASE_URL + '/api/v1/discussion/remove/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const discussionListMine = async (body) => {
    return postRequest(BASE_URL + '/api/v1/discussion/list_mine/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const discussionListByProfile = async (body) => {
    return postRequest(BASE_URL + '/api/v1/discussion/list_by_profile/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const discussionSearch = async (body) => {
    return postRequest(BASE_URL + '/api/v1/discussion/search/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const reportDiscussion = async (body) => {
    return postRequest(BASE_URL + '/api/v1/discussion/report/', body, {
        withFormData: true,
        method: 'POST',
    })
}
const answerAdd = async (body) => {
    return postRequest(BASE_URL + '/api/v1/answer/add/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const answerEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/answer/edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const answerRemove = async (body) => {
    return postRequest(BASE_URL + '/api/v1/answer/remove/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const reportAnswer = async (body) => {
    return postRequest(BASE_URL + '/api/v1/answer/report/', body, {
        withFormData: true,
        method: 'POST',
    })
}

// visit
const visitListDoctors = async (body) => {
    return postRequest(BASE_URL + '/api/v1/visit/list_doctors/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const visitListMine = async (body) => {
    return postRequest(BASE_URL + '/api/v1/visit/list_mine/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const visitDoctorViewDayVisits = async (body) => {
    return postRequest(BASE_URL + '/api/v1/visit/doctor_view_day_visits/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const visitUserViewDayVisits = async (body) => {
    return postRequest(BASE_URL + '/api/v1/visit/user_view_day_visits/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const visitToggleVisitActive = async (body) => {
    return postRequest(BASE_URL + '/api/v1/visit/toggle_visit_active/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const visitToggleVisitReserve = async (body) => {
    return postRequest(BASE_URL + '/api/v1/visit/toggle_visit_reserve/', body, {
        withFormData: true,
        method: 'POST',
    });
};


// webinar
const webinarDetail = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/detail/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarAdd = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/add/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarFetchEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/fetch_edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarEdit = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/edit/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarRemove = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/remove/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarAdminList = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/admin_list/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarListMine = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/list_mine/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarListEnroll = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/list_enroll/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarListByProfile = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/list_by_profile/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarSearch = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/search/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarEnroll = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/enroll/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarModeratorUrl = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/moderator_url/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarAttendeeUrl = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/attendee_url/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarPreparePurchase = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/prepare_purchase/', body, {
        withFormData: true,
        method: 'POST',
    });
};
const webinarCalculateDiscountCode = async (body) => {
    return postRequest(BASE_URL + '/api/v1/webinar/calculate_discount_code/', body, {
        withFormData: true,
        method: 'POST',
    });
};

export const api = {
    // auth
    profileLogin,
    profileVerify,
    // home
    homeTagList,
    homeFetchTag,
    homeHeroSlides,
    homeHeroAdminList,
    homeHeroSave,
    homeHeroRemove,
    homeCarousels,
    homeCarouselAdminList,
    homeCarouselSave,
    homeCarouselRemove,
    homeCarouselItemSave,
    homeCarouselItemRemove,
    // profile
    profileDetail,
    profileFetchEdit,
    profileEdit,
    reportProfile,
    profileAdminUserList,
    profileAdminUserSave,
    profileAdminUserRemove,
    // doctor
    doctorFetchEdit,
    doctorEdit,
    doctorSearch,
    doctorAdminList,
    doctorAdminSave,
    doctorAdminRemove,
    // payment
    paymentList,
    paymentDetail,
    subscriptionList,
    subscriptionAdminList,
    subscriptionSave,
    subscriptionToggleActive,
    subscriptionPreparePurchase,
    subscriptionMyList,
    videoClipList,
    videoClipDetail,
    videoClipWatch,
    videoClipAdminList,
    videoClipSave,
    videoClipRemove,
    // expertise
    expertiseList,
    listDoctorExpertises,
    listWorkshopExpertises,
    listClipExpertises,
    listWebinarExpertises,
    // category
    categoryList,
    // workshop
    workshopDetail,
    workshopAdd,
    workshopFetchEdit,
    workshopEdit,
    workshopRemove,
    workshopAdminList,
    workshopListMine,
    workshopListEnroll,
    workshopListByProfile,
    workshopListByExpertise,
    workshopSearch,
    workshopEnroll,
    workshopPreparePurchase,
    workshopCalculateDiscountCode,
    episodeAdd,
    episodeFetchEdit,
    episodeEdit,
    episodeRemove,
    workshopAdminConfirm,
    // publication
    publicationDetail,
    publicationAdd,
    publicationFetchEdit,
    publicationEdit,
    publicationRemove,
    publicationListMine,
    publicationListByProfile,
    publicationSearch,
    // discussion
    discussionDetail,
    discussionAdd,
    discussionEdit,
    discussionRemove,
    discussionListMine,
    discussionListByProfile,
    discussionSearch,
    reportDiscussion,
    answerAdd,
    answerEdit,
    answerRemove,
    reportAnswer,
    // visit
    visitListDoctors,
    visitListMine,
    visitDoctorViewDayVisits,
    visitUserViewDayVisits,
    visitToggleVisitActive,
    visitToggleVisitReserve,
    // webinar
    webinarDetail,
    webinarAdd,
    webinarFetchEdit,
    webinarEdit,
    webinarRemove,
    webinarAdminList,
    webinarListMine,
    webinarListEnroll,
    webinarListByProfile,
    webinarSearch,
    webinarEnroll,
    webinarModeratorUrl,
    webinarAttendeeUrl,
    webinarPreparePurchase,
    webinarCalculateDiscountCode,
}
